import { BaseValidationRule, IValidateable } from '@aurelia/validation';

export class AbnNameSelectedPropertyRule extends BaseValidationRule {
  public constructor(private propertyName: string) {
    super();
  }

  public execute(value: any, _object?: IValidateable): boolean {
    return _object.selectedResult !== null && _object.selectedResult.name !== '';
  }
}
